import { FieldAttributes, useField } from 'formik';
import React, { useCallback } from 'react';

import { FormikCheckbox } from 'components/FormikCheckbox';

type Props = Omit<
  FieldAttributes<any>,
  'checked' | 'indeterminate' | 'onChange' | 'type'
> & {
  onChange?: (checked: boolean) => void;
};

export const FormikNullableBooleanCheckbox: React.FC<Props> = ({
  name,
  onChange,
  ...rest
}) => {
  const [field, , helpers] = useField<boolean | null>(name);

  const handleChange = useCallback(
    (checked: boolean) => {
      helpers.setValue(checked);
      helpers.setTouched(true);
      onChange?.(checked);
    },
    [helpers, onChange],
  );

  return (
    <FormikCheckbox
      {...rest}
      name={name}
      checked={field.value === true}
      indeterminate={field.value == null}
      onChange={handleChange}
    />
  );
};
